import InfoIcon from '@/assets/icons/info.svg?react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover/popover.component';
import { YesNoQuestion } from '@/gql/graphql';

interface QuestionTextProps {
  question: YesNoQuestion;
}

export const QuestionText = ({ question }: QuestionTextProps) => {
  return (
    <Popover>
      <div>
        <PopoverTrigger
          data-testid={`question-${question.id}-input-description-trigger`}
          className="mb-6 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[green] focus-visible:ring-offset-2 focus-visible:rounded"
        >
          <div className="flex flex-row gap-x-1 items-center">
            <p data-testid={`question-${question.id}-input-question`} className="typo-primary-500 text-left inline">
              <span>{question.question}</span>
              <InfoIcon role="img" aria-label="Question information icon" className="w-4 h-4 ml-1 mb-1 inline" />
            </p>
          </div>
        </PopoverTrigger>
        <PopoverContent aria-label="question additional information " align="end" side="right" alignOffset={16}>
          <p data-testid={`question-${question.id}-input-description-id`} className="typo-primary-500">
            {question.id}
          </p>
          <p data-testid={`question-${question.id}-input-description-content`} className="typo-primary-400">
            {question.description}
          </p>
        </PopoverContent>
      </div>
    </Popover>
  );
};
